//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum ShowRightAnswersOptions {
	NeverShow = 0,
	ShowWrongSelected = 1,
	ShowCorrectAndWrongIfNoAttempts = 2
}
